import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AllJobsResponse } from '@edtech-ui/core/models/company-management/admin-all-jobs';
import { CompanyPublishJobDetailsResponse, CompanyPublishPayload } from '@edtech-ui/core/models/company-management/company-approval-status';
import { CompanyPendingJobsResponse } from '@edtech-ui/core/models/company-management/get-all-pending-company';
import { JobApproveDetailsResponse } from '@edtech-ui/core/models/company-management/get-job-by-id';
import { CompanyJobApprovePayload, CompanyJobRejectPayload, CompnayApproveJobResponse } from '@edtech-ui/core/models/company-management/job-approval-approved-status';
import { CreateJobRecruitmentApiResponse, CreateJobRecruitmentPayload } from '@edtech-ui/core/models/recruitment/create-job';
import { JobPostingApiResponse } from '@edtech-ui/core/models/recruitment/get-all-job-listing';
import { CompanyJobDetailResponse } from '@edtech-ui/core/models/recruitment/get-job-by-id';
import { UpdateCompanyJobDetailResponse, UpdateJobPostingPayload } from '@edtech-ui/core/models/recruitment/update-job-posting';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class RecruitmentJobService {

	apiUrl = environment.jobApiUrl;

	lastJobsPage = 1;


	constructor(
		private http: HttpClient
	) { }


	postCreateJob(payload: CreateJobRecruitmentPayload, companyId: string): Observable<CreateJobRecruitmentApiResponse> {
		const params = new HttpParams().set('company_id', companyId)
		return this.http.post<CreateJobRecruitmentApiResponse>(`${this.apiUrl}/`, payload, { params });
	}


	getAllJobPosting(
		companyId: string,
		page: number = 1,
		limit: number = 10,
		status?: string,
		search?: string,
		filter?: any
	): Observable<JobPostingApiResponse> {

		let params = new HttpParams()
			.set('company_id', companyId)
			.set('page', page.toString())
			.set('limit', limit.toString());

		if (status) {
			params = params.set('status', status);
		}

		if (search) {
			params = params.set('search', search);
		}

		if (filter?.job_type) {
			params = params.set('job_type', filter.job_type);
		}

		if (filter?.work_mode) {
			params = params.set('work_mode', filter.work_mode);
		}

		if (filter?.is_visible !== undefined && filter?.is_visible !== null) {
			params = params.set('is_visible', String(filter.is_visible));
		}
		return this.http.get<JobPostingApiResponse>(`${this.apiUrl}/`, { params });
	}

	getJobPostById(jobId: string, companyId: string): Observable<CompanyJobDetailResponse> {
		const params = new HttpParams().set('company_id', companyId)
		return this.http.get<CompanyJobDetailResponse>(`${this.apiUrl}/${jobId}`, { params });
	}

	getPublicJobPostById(jobId: string): Observable<CompanyJobDetailResponse> {
		return this.http.get<CompanyJobDetailResponse>(`${this.apiUrl}/public/${jobId}`);
	}

	patchJobPosting(jobId: string, companyId: string, payload: UpdateJobPostingPayload): Observable<UpdateCompanyJobDetailResponse> {
		const params = new HttpParams().set('company_id', companyId)
		return this.http.put<UpdateCompanyJobDetailResponse>(`${this.apiUrl}/${jobId}`, payload, { params })
	}


	postCloseActiveJob(jobId: string, companyId: string): Observable<any> {
		const params = new HttpParams().set('company_id', companyId)
		return this.http.post<any>(`${this.apiUrl}/${jobId}/close`, {}, { params })
	}


	deleteJobPosting(jobId: string): Observable<any> {
		return this.http.delete<any>(`${this.apiUrl}/jobPosting/${jobId}`);
	}

	deleteJob(jobId: string, companyId: string): Observable<any> {
		const params = new HttpParams().set('company_id', companyId);
		return this.http.delete<any>(`${this.apiUrl}/${jobId}`, { params });
	}


	postCompanyPublish(payload: CompanyPublishPayload, jobId: string, companyId: string): Observable<CompanyPublishJobDetailsResponse> {
		const params = new HttpParams().set('company_id', companyId)
		return this.http.post<CompanyPublishJobDetailsResponse>(`${this.apiUrl}/${jobId}/publish`, payload, { params })
	}


	getCompanyPendingApproval(page: number, limit: number, status?: string, search?: string, job_type?: string, filter?: any): Observable<CompanyPendingJobsResponse> {
		let params: any = { page, limit };
		if (status) { params.status = status; }
		if (search) { params.search = search; }
		if (job_type) { params.job_type = job_type; }
		if (filter?.created_at) { params.created_at = filter.created_at; }
		if (filter?.submitted_at) { params.submitted_at = filter.submitted_at; }
		if (filter?.company_name) { params.company_name = filter.company_name; }
		if (filter?.job_title) { params.job_title = filter.job_title; }
		if (filter?.work_mode) { params.work_mode = filter.work_mode; }
		return this.http.get<CompanyPendingJobsResponse>(`${this.apiUrl}/admin/approvals`, { params });
	}


	postCompnayApproveJob(jobId: string, payload: CompanyJobApprovePayload): Observable<CompnayApproveJobResponse> {
		return this.http.post<CompnayApproveJobResponse>(`${this.apiUrl}/admin/${jobId}/approve`, payload)
	}


	postCompnayRejectJob(jobId: string, payload: CompanyJobRejectPayload): Observable<CompnayApproveJobResponse> {
		return this.http.post<CompnayApproveJobResponse>(`${this.apiUrl}/admin/${jobId}/reject`, payload)
	}


	getAllPendingCompanyById(jobId: string): Observable<JobApproveDetailsResponse> {
		return this.http.get<JobApproveDetailsResponse>(`${this.apiUrl}/admin/${jobId}`)
	}


	getAllJobs(page: number = 1, limit: number = 10, status?: string, search?: string, filter?: any): Observable<AllJobsResponse> {

		let params = new HttpParams().set('page', page.toString()).set('limit', limit.toString());

		if (status) {
			params = params.set('status', status);
		}

		if (search) {
			params = params.set('search', search);
		}

		if (filter?.job_type) {
			params = params.set('job_type', filter.job_type);
		}

		if (filter?.work_mode) {
			params = params.set('work_mode', filter.work_mode);
		}

		if (filter?.created_at) {
			params = params.set('created_at', filter.created_at);
		}

		if (filter?.submitted_at) {
			params = params.set('submitted_at', filter.submitted_at);
		}

		if (filter?.company_name) {
			params = params.set('company_name', filter.company_name);
		}

		if (filter?.job_title) {
			params = params.set('job_title', filter.job_title);
		}
		return this.http.get<AllJobsResponse>(`${this.apiUrl}/admin/list`, { params });
	}
}